export default class VodEpisodeService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('vodEpisodes', params)
	}

	getSimpleList(params) {
		return this.apiService.callGet('vodEpisodes/simple', params)
	}

	getPackagesForService(params) {
		return this.apiService.callGet('vodEpisodes/packagesForService', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('vodEpisodes/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/VodEpisodeService.js